<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- container -->
    <div class="container">
      <div class="order-container">
        <div :class="['status-box', (orderDetail.status=='1'||orderDetail.status=='2')?'finished':'unfinished']">
          <span class="title">{{payStatus}}</span>
        </div>
        <div class="orderid-box">
          <span class="orderid">看购订单号：{{orderId}}</span>
          <span class="desc">（有订单问题可拨打看购客服电话<i>400-6776-501</i>，工作时间: 9:00-18:00）</span>
        </div>
        <table class="order-table">
          <thead>
            <tr>
              <th>影片</th>
              <th>时间</th>
              <th>影院</th>
              <th>座位</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="movie-name">《{{orderDetail.filmName}}》</td>
              <td class="showtime">{{orderDetail.showDate}}</td>
              <td class="cinema-name">{{orderDetail.cinemaName}}</td>
              <td>
                <span class="hall">{{orderDetail.hallName}}</span>
                <div class="seats">
                  <span class="seat">{{orderDetail.seatName}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="order-bottom-box">
          <div class="order-bottom">
            <div class="cinema-info">
              <p class="name">{{orderDetail.cinemaName}}</p>
              <p class="address">地址: {{orderDetail.cienmaAddress}}</p>
              <p class="address">电话: {{orderDetail.tel}}</p>
            </div>
            <div class="price-box">
              <span>总价:</span>
              <!-- ￥ -->
              <span class="price"><i></i>{{orderDetail.totalPrice}}</span>
            </div>
          </div>
          <div class="btn-wrapper" v-if="orderDetail.status == '0'">
            <p class="btn" @click="toConfirmOrder()">立即支付</p>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {getOrderDetail} from '@/api/order'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 订单id
        orderId: this.$route.query.orderId,
        // 选中的当前导航
        selected: "",
        // 城市名称
        cityName: '',
        // 订单状态
        payStatus: '',
        // 影片信息
        orderDetail: {},
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 获取城市名称
        this.cityName = localStorage.getItem('cityName');
        // 详细数据
        this.getOrderDetail();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.cityName = localStorage.getItem("cityName");
      },
      // 获取订单列表
      getOrderDetail() {
        let signdata = {orderId: this.orderId};
        let data = {orderId: this.orderId, signdata: signdata};
        getOrderDetail(data).then(response => {
          this.orderDetail = response.data;
          //订单状态-中文
          let status = this.orderDetail.status;
          if (status == 0) {
            this.payStatus = '待支付'
          } else if (status == 1) {
            this.payStatus = '已支付'
          } else if (status == 2) {
            this.payStatus = '已完成'
          } else if (status == 3) {
            this.payStatus = '出票失败'
          } else if (status == 4) {
            this.payStatus = '待退款'
          } else if (status == 8) {
            this.payStatus = '已退款'
          } else if (status == 9) {
            this.payStatus = '已取消'
          }
        });
      },
      // 立即支付按钮--跳转到确认订单页面
      toConfirmOrder(){
        this.$router.push({path: '/confirmOrder', query: {orderId: this.orderId}});
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-top: 120px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    width: 75%;
  }
  .order-container {
    margin-top: 40px;
  }
  .status-box {
    height: 110px;
    padding-left: 85px;
    padding-top: 28px;
    margin-bottom: 40px;
    background-repeat: no-repeat;
    background-position: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: left;
  }
  .status-box.finished {
    padding-top: 40px;
    background-color: #f4fff8;
    background-image: url(data:image/png;base64,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);
  }
  .status-box .title {
    font-size: 24px;
    font-weight: 700;
  }
  .status-box.finished .title {
    color: #26ce61;
  }
  .status-box.unfinished {
    padding-top: 40px;
    background-color: #f4fff8;
    background-image: url(data:image/png;base64,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);
  }
  .status-box.unfinished .title {
    color: #faaf00;
  }
  .orderid-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .orderid-box .order-id {
    font-size: 16px;
    color: #333;
  }
  .orderid-box .desc {
    font-size: 12px;
    color: #666;
    float: right;
  }
  .orderid-box .desc i {
    color: #f03d37;
    font-style: normal;
  }
  .order-table {
    width: 100%;
    border: 1px solid #e5e5e5;
    border-spacing: 0;
    margin-bottom: 60px;
  }
  .order-table thead {
    background-color: #f7f7f7;
  }
  .order-table thead th {
    font-size: 16px;
    color: #333;
    width: 25%;
    padding: 14px 0;
    font-weight: 400;
  }
  .order-table td {
    text-align: center;
    padding: 20px 0;
    color: #333;
  }
  .order-table .movie-name {
    font-size: 16px;
  }
  .order-table .showtime {
    font-size: 14px;
    color: #f03d37;
  }
  .order-table .cinema-name {
    font-size: 14px;
  }
  .order-table .hall {
    display: inline-block;
    font-size: 14px;
    color: #424242;
    font-weight: 700;
    margin-right: 10px;
    /*vertical-align: top;*/
  }
  .order-table .seats {
    display: inline-block;
    text-align: left;
  }
  .order-table .seats .seat {
    margin-right: 2px;
    font-size: 14px;
    font-weight: 700;
  }
  .order-bottom-box{
    margin-top: -20px;
  }
  .order-bottom {
    display: flex;
    justify-content: space-between;
  }
  .cinema-info {
    display: inline-block;
    color: #333;
    text-align: left;
  }
  .cinema-info .name {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 700;
  }
  .cinema-info .address{
    font-size: 14px;
    margin-bottom: 4px;
  }
  .price-box {
    font-size: 14px;
    color: #333;
    float: right;
    margin-top: 35px;
  }
  .price-box .price {
    font-size: 36px;
    color: #f03d37;
    font-weight: 700;
  }
  .price-box .price i{
    font-size: 24px;
  }
  .btn-wrapper {
    text-align: right;
  }
  .btn-wrapper .btn {
    cursor: pointer;
    display: inline-block;
    margin-top: 16px;
    width: 190px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background-color: #f03d37;
    border-radius: 100px;
    -webkit-box-shadow: 0 2px 10px -2px #f03d37;
    box-shadow: 0 2px 10px -2px #f03d37;
  }
</style>


// WEBPACK FOOTER //
// src/views/orderDetail.vue